module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-image",
    class: {
      'is-overhidden': _vm.showOriginPic, 'is-round': _vm.shape === 'round'
    },
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px'
    }),
    on: {
      "mouseover": function($event) {
        _vm.isSHow = true
      },
      "mouseout": function($event) {
        _vm.isSHow = false
      },
      "click": _vm.handleImg
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.src),
      expression: "src"
    }],
    staticClass: "ts-image-img",
    class: {
      'is-view': _vm.showOriginPic, 'is-disabledHover': _vm.disabledHover
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e8d67682"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsImage.vue
// module id = 862
// module chunks = 39